// @ts-nocheck

import { reduce, size, mapValues } from 'lodash';

import BetBuilder from '../../../states/betbuilder';
import { BasketModes, BasketItemStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';

const { getMode, generateSystems } = BasketUtils;

const basketSanitize = (state, action, { entities }) => {
  const { mode, items, systems, defaultStake, isCashout } = state;
  const { matches, bets, outcomes, odds, sports, categories, tournaments } = entities;
  let hasAtLeastOneItemFromPreloadedState = false;
  const correctedMatchIds = [];

  const nextItems = reduce(
    items,
    (finalItems, item) => {
      const { matchId, betId, oddId, sortBy, addedFromPreloadedState, betbuilder, selectionItems, value } = item;
      const match = matches[matchId];

      if (betbuilder && !!match) {
        const canBeAdded = BetBuilder.isItemsOutcomesAndBetsValid(selectionItems, bets, outcomes);
        if (canBeAdded) {
          if (addedFromPreloadedState) {
            hasAtLeastOneItemFromPreloadedState = true;
            return {
              ...finalItems,
              [oddId]: {
                status: BasketItemStatuses.OK,
                oddId,
                matchId,
                sportId: match.sportId,
                value,
                banker: false,
                stake: BasketUtils.formatStake(defaultStake),
                sortBy,
              },
            };
          }
          return {
            ...finalItems,
            [oddId]: item,
          };
        }
        correctedMatchIds.push(matchId);
      } else {
        const odd = odds[oddId];

        if (!!match && !!bets[betId] && !!outcomes[oddId] && !!odd) {
          const { sportId, categoryId, tournamentId } = match;

          if (!!sports[sportId] && !!categories[categoryId] && !!tournaments[tournamentId]) {
            // Dans le cas ou on nous a fourni des items a ajouter au panier,
            // nous devons completer les informations du pari.
            // (value, etc..)
            if (addedFromPreloadedState) {
              hasAtLeastOneItemFromPreloadedState = true;
              return {
                ...finalItems,
                [oddId]: {
                  status: BasketItemStatuses.OK,
                  oddId,
                  matchId,
                  sportId: match.sportId,
                  betId,
                  value: odd,
                  banker: false,
                  stake: BasketUtils.formatStake(defaultStake),
                  sortBy,
                },
              };
            }
            return {
              ...finalItems,
              [oddId]: item,
            };
          }
        }
      }
      return finalItems;
    },
    {},
  );

  // recompute mode
  let nextMode = mode;
  if (size(items) !== size(nextItems) || hasAtLeastOneItemFromPreloadedState) {
    nextMode = getMode(mode, nextItems, { matches });
  }

  // recompute systems
  let nextSystems = systems;
  if (nextMode === BasketModes.SYSTEM && (size(items) !== size(nextItems) || hasAtLeastOneItemFromPreloadedState)) {
    nextSystems = generateSystems({
      items: nextItems,
      defaultCheckboxValue: false,
    });
  }

  const nextState = {
    ...state,
    mode: nextMode,
    systems: nextSystems,
    items: nextItems,
  };

  if (!Object.keys(nextItems).length) {
    nextState.cachedMMAPIResponsesInfos = {};
  } else if (correctedMatchIds.length && nextState.cachedMMAPIResponsesInfos) {
    const nextCachedMMAPIResponsesInfos = { ...nextState.cachedMMAPIResponsesInfos };

    for (const correctedMatchId of correctedMatchIds) {
      delete nextCachedMMAPIResponsesInfos[correctedMatchId];
    }

    nextState.cachedMMAPIResponsesInfos = nextCachedMMAPIResponsesInfos;
  }

  // is cashout, check that all initial item are present
  if (isCashout) {
    if (size(items) !== size(nextItems) || hasAtLeastOneItemFromPreloadedState) {
      const computedNextItems = mapValues(nextItems, (x) => ({ ...x, cashout: false }));

      nextState.items = computedNextItems;
      nextState.isCashout = false;
      nextState.cashoutBetslipType = undefined;
      nextState.cashoutBetslipId = undefined;

      return nextState;
    }
  }

  return nextState;
};

export default basketSanitize;
